"use strict";
/*
Session
Shifts
Travel
Workflow Dev
Recovery
Break

flowKind is authoritative for timer side-effects (not pnTaskGroup alone).
See docs/product/action-flow-planning.md
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultActions1 = void 0;
var actionFlowOverlays_1 = require("./actionFlowOverlays");
/** Core session/travel/work — flowKind mostly inline; configure fills gaps only. */
var defaultActions1Raw = [
    {
        id: 2000,
        viewGroup: 'Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: 'Session',
        // Open Session envelope (Focus S). No "Shift" topic — commercial T&A later if needed.
        caption: 'Start session',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        flowKind: 'S',
        timeStyle: 'duration',
        opensFocus: true,
        auditRow: {
            taskGroup: 'Session',
            topicGroup: null,
            topicDetail: 'Start',
            body: null,
            tagAux: null,
            value: 100,
        },
    },
    {
        id: 2010,
        viewGroup: 'Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: null,
        caption: 'Session work',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        // T fragment under Session taxonomy — not the S envelope
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Start',
            topicDetail: null,
            body: null,
            tagAux: null,
            value: 100,
        },
    },
    {
        id: 2050,
        viewGroup: 'Travel, Focus-Nav',
        viewLevel: 1,
        groupTitle: 'Travel',
        caption: 'Start',
        materialIcon: 'directions_run',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        showBodyInput: true,
        showValueInput: true,
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Travel',
            topicDetail: 'Start',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 2055,
        viewGroup: 'Travel, Focus-Nav',
        viewLevel: 1,
        groupTitle: null,
        caption: 'Arrive',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        showBodyInput: true,
        showValueInput: true,
        flowKind: 'seal',
        timeStyle: 'stamp',
        sealScope: 't',
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Travel',
            topicDetail: 'Arrive',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 10,
        viewGroup: 'Session, Travel, Focus-Nav',
        viewLevel: 0,
        groupTitle: 'Start',
        caption: 'Planning',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Planning',
            topicDetail: 'Start',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 100,
        viewGroup: 'Session, Travel',
        viewLevel: 0,
        caption: 'Work',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Start',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 102,
        viewGroup: 'Session, Travel',
        viewLevel: 1,
        caption: 'Work (Earlier)',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        // Backdated stamp — not a new open timer
        flowKind: 'I',
        timeStyle: 'stamp',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Start',
            topicDetail: 'Earlier',
            body: null,
            tagAux: null,
            value: -99,
        },
    },
    {
        id: 200,
        viewGroup: 'Session, Focus-Nav',
        viewLevel: 1,
        caption: 'Other Admin',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        showBodyInput: true,
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Admin',
            topicDetail: 'Other',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 9200,
        viewGroup: 'Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: 'Systems',
        caption: 'Workflow Dev',
        cssStyle: { background: 'rgba(30,240,240,0.3)' },
        showBodyInput: true,
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Workflow',
            topicDetail: 'Developing',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 9500,
        viewGroup: 'Session, Inventory, Logistics, Recovery',
        viewLevel: 1,
        groupTitle: 'Recovery',
        caption: 'Investigation',
        cssStyle: { background: 'rgba(240,30,30,0.3)' },
        showBodyInput: true,
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Recovery',
            topicDetail: 'Investigation',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 9550,
        viewGroup: 'Session, Inventory, Logistics, Recovery',
        viewLevel: 1,
        caption: 'Comm.',
        cssStyle: { background: 'rgba(240,30,30,0.3)' },
        showBodyInput: true,
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Recovery',
            topicDetail: 'Communication',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 9590,
        viewGroup: 'Session, Inventory, Logistics, Recovery',
        viewLevel: 1,
        caption: 'On Site Visit',
        cssStyle: { background: 'rgba(240,30,30,0.3)' },
        showBodyInput: true,
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Recovery',
            topicDetail: 'On Site Visit',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 2100,
        viewGroup: 'Travel, Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: 'Break',
        caption: 'Start Break',
        cssStyle: { background: 'rgba(30,80,240,0.3)' },
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Break',
            topicDetail: 'Start',
            body: null,
            tagAux: null,
            value: 50,
        },
    },
    {
        id: 2150,
        viewGroup: 'Travel, Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: null,
        caption: 'Finish Break',
        cssStyle: { background: 'rgba(30,80,240,0.3)' },
        flowKind: 'seal',
        timeStyle: 'stamp',
        sealScope: 't',
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Break',
            topicDetail: 'Finish',
            body: null,
            tagAux: null,
            value: 100,
        },
    },
    {
        id: 2400,
        viewGroup: 'Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: 'Reflection',
        caption: 'Session reflection',
        cssStyle: { background: 'rgba(40,200,160,0.3)' },
        showBodyInput: true,
        // Text block only — not session start/finish (not commercial T&A “shift”)
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Reflection',
            body: null,
            tagAux: null,
            value: 100,
        },
    },
    {
        id: 2200,
        viewGroup: 'Travel, Focus-Nav',
        viewLevel: 1,
        groupTitle: null,
        caption: 'Pack up',
        cssStyle: { background: 'rgba(240,80,30,0.3)' },
        showBodyInput: true,
        // Same as Travel Start: open Focus T, stays open until seal/unlink/short stop
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Travel',
            topicDetail: 'Pack up',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 2500,
        viewGroup: 'Session, Focus-Nav',
        viewLevel: 1,
        groupTitle: 'Session',
        // Peel outermost timer (T if open, else S). No zero-time Finish stamp.
        // Session envelope ≠ work “shift”; short coding/tinker sessions use the same S.
        caption: 'Sign off',
        cssStyle: { background: 'rgba(240,80,30,0.3)' },
        flowKind: 'seal',
        timeStyle: 'stamp',
        sealScope: 's_and_t',
        auditRow: {
            taskGroup: 'Session',
            topicGroup: 'Session',
            topicDetail: 'Sign off',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 5100,
        viewGroup: 'Info, Impact, Focus-Nav',
        viewLevel: 0,
        groupTitle: 'Safety',
        caption: 'Risk',
        cssStyle: { background: 'White' },
        showBodyInput: true,
        bodyPlaceholder: 'identified',
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Risk',
            topicGroup: 'Identified',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 5200,
        viewGroup: 'Info',
        viewLevel: 1,
        taskImage: null,
        groupTitle: 'Risk Control',
        caption: 'Measure',
        cssStyle: { background: 'White' },
        showBodyInput: true,
        bodyPlaceholder: 'details',
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Risk',
            topicGroup: 'Control',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 100100,
        viewGroup: 'Food, Meal',
        viewLevel: 1,
        groupTitle: 'Meal',
        caption: 'Prep',
        tooltip: '',
        cssStyle: { background: 'White' },
        showBodyInput: true,
        serviceRealm: 'my-food',
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Meal',
            topicGroup: 'Prep',
            topicDetail: 'Start',
            body: '',
            tagAux: null,
            value: 0,
        },
    },
];
exports.defaultActions1 = (0, actionFlowOverlays_1.configureDefaultActions1)(defaultActions1Raw);
